import { CustomerDto } from '@careapp-group/ng-sdk-v2-new';
import { CareAppListActionFactory } from '../action-factory';

export class MemberCustomersActionFactory extends CareAppListActionFactory<CustomerDto[]> {
  constructor() {
    super(`MemberCustomers`);
  }

  readonly REQUEST_REMOVE_MEMBER_FROM_CUSTOMER = `[${this.type}][Request] Remove Member from Customer`;

  RequestRemoveMemberFromCustomer(payload: { memberId: string; customerId: string }) {
    return {
      type: this.REQUEST_REMOVE_MEMBER_FROM_CUSTOMER,
      payload,
    };
  }
}

export const MemberCustomers = new MemberCustomersActionFactory();
